var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompanyIconClient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_18337_10178)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.7344,
    y: 28.7344,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7344 44.0777C49.7344 42.7835 50.7835 41.7344 52.0777 41.7344H68.4809C69.7751 41.7344 70.8242 42.7835 70.8242 44.0777V79.2274H49.7344V44.0777Z",
    fill: "#2896F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1784 52.2786C56.6445 52.2786 57.0915 52.0935 57.4211 51.7639C57.7507 51.4343 57.9359 50.9873 57.9359 50.5212C57.9359 50.055 57.7507 49.608 57.4211 49.2784C57.0915 48.9488 56.6445 48.7637 56.1784 48.7637C55.7123 48.7637 55.2652 48.9488 54.9357 49.2784C54.6061 49.608 54.4209 50.055 54.4209 50.5212C54.4209 50.9873 54.6061 51.4343 54.9357 51.7639C55.2652 52.0935 55.7123 52.2786 56.1784 52.2786Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.138 50.5212C66.138 50.055 65.9529 49.608 65.6233 49.2784C65.2937 48.9488 64.8466 48.7637 64.3805 48.7637C63.9144 48.7637 63.4674 48.9488 63.1378 49.2784C62.8082 49.608 62.623 50.055 62.623 50.5212C62.623 50.9873 62.8082 51.4343 63.1378 51.7639C63.4674 52.0935 63.9144 52.2786 64.3805 52.2786C64.8466 52.2786 65.2937 52.0935 65.6233 51.7639C65.9529 51.4343 66.138 50.9873 66.138 50.5212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.138 57.5514C66.138 58.0175 65.9529 58.4646 65.6233 58.7942C65.2937 59.1238 64.8466 59.3089 64.3805 59.3089C63.9144 59.3089 63.4674 59.1238 63.1378 58.7942C62.8082 58.4646 62.623 58.0175 62.623 57.5514C62.623 57.0853 62.8082 56.6383 63.1378 56.3087C63.4674 55.9791 63.9144 55.7939 64.3805 55.7939C64.8466 55.7939 65.2937 55.9791 65.6233 56.3087C65.9529 56.6383 66.138 57.0853 66.138 57.5514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.138 64.5817C66.138 65.0478 65.9529 65.4948 65.6233 65.8244C65.2937 66.154 64.8466 66.3392 64.3805 66.3392C63.9144 66.3392 63.4674 66.154 63.1378 65.8244C62.8082 65.4948 62.623 65.0478 62.623 64.5817C62.623 64.1156 62.8082 63.6686 63.1378 63.339C63.4674 63.0094 63.9144 62.8242 64.3805 62.8242C64.8466 62.8242 65.2937 63.0094 65.6233 63.339C65.9529 63.6686 66.138 64.1156 66.138 64.5817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9359 57.5514C57.9359 57.0853 57.7507 56.6383 57.4211 56.3087C57.0915 55.9791 56.6445 55.7939 56.1784 55.7939C55.7123 55.7939 55.2652 55.9791 54.9357 56.3087C54.6061 56.6383 54.4209 57.0853 54.4209 57.5514C54.4209 58.0175 54.6061 58.4646 54.9357 58.7942C55.2652 59.1238 55.7123 59.3089 56.1784 59.3089C56.6445 59.3089 57.0915 59.1238 57.4211 58.7942C57.7507 58.4646 57.9359 58.0175 57.9359 57.5514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9359 64.5817C57.9359 65.0478 57.7507 65.4948 57.4211 65.8244C57.0915 66.154 56.6445 66.3392 56.1784 66.3392C55.7123 66.3392 55.2652 66.154 54.9357 65.8244C54.6061 65.4948 54.4209 65.0478 54.4209 64.5817C54.4209 64.1156 54.6061 63.6686 54.9357 63.339C55.2652 63.0094 55.7123 62.8242 56.1784 62.8242C56.6445 62.8242 57.0915 63.0094 57.4211 63.339C57.7507 63.6686 57.9359 64.1156 57.9359 64.5817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4209 72.1968C54.4209 70.9027 55.47 69.8535 56.7642 69.8535H63.7942C65.0883 69.8535 66.1375 70.9027 66.1375 72.1968V79.2268H54.4209V72.1968Z",
    fill: "#DFDFDF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_18337_10178",
    x: -0.00031662,
    y: -0.00031662,
    width: 121.469,
    height: 121.469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.3673
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18337_10178"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18337_10178",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIconClient);
export default __webpack_public_path__ + "static/media/companyIconClient.af3d37c36cbe65ac2a5057c969c280b0.svg";
export { ForwardRef as ReactComponent };